<app-main-nav-bar></app-main-nav-bar>
<div class="main">
  <div class="wrap">
    <div class="request elem" style="display: block;">
      <div class="row">
        <div class="col col-12">
          <div class="head">
            <h2>بیمه نامه&zwnj;ها من</h2>
            <p>درخواست&zwnj;های بیمه {{settings.translateEnglish(insurance.productName)}}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-12">
          <div class="list">
            <div *ngFor="let subset of insurance.subsetList; last as isLast" class="item" data-request="566">
              <div class="avatar"><i
                class="icon {{subset.locked ? 'ico-person-done-outline': 'ico-person-add-outline'}}"></i></div>
              <div class="pull-left" style="margin-left: 0; margin-top: 0">
                <div class="controll">
                  <button *ngIf="!subset.locked" (click)="openDialog(subset)" class="btn4 btn-delete"
                          data-person="fyvb73c"
                          style="margin-left: 19px; border:lightgray;border-radius: 100%;height: 27px;">
                    <i class="icon ico-trash-2-outline"></i></button>
                </div>
              </div>
              <div class="text" style="text-align: right"><h2>{{subset.firstName + ' ' + subset.lastName + '(' + settings.translateEnglish(subset.relation) + ')'}}</h2>
              </div>
              <div *ngIf="isLast && insurance.multipleSubRequests"
                   (click)="addNewSubset(insurance.subsetList)"
                   class="sub-count">
                <div class="text">
                  <i class="icon ico-person-add-outline"></i>
                  <span>افزودن بیمه گذار جدید</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-custom-button
        [BackButton]="false"
        [LabelText]="'افزودن بیمه گذار'"
        [Show]="!insurance.subsetList.length"
        (OnClick)="addNewSubset(insurance.subsetList)"
      ></app-custom-button>
      <app-custom-button
        [BackButton]="true"
        [disabled]="!insurance.subsetList.length"
        [LabelText]="'ادامه'"
        [Show]="insurance.subsetList.length !== 0"
        (OnClick)="submit()"
        [backUrl]="'/insurance-service/' + productName + '/basic-information'"
      ></app-custom-button>
    </div>
  </div>
</div>

